import { useEffect, useState } from 'react'
import { reportWarning } from 'src/dataLayer/remoteData/rollbar'
import {
  createSpeedCurveScriptElement,
  initializeSpeedCurveLux,
} from 'src/viewLayer/helpers/speedcurve'

export default function CollectPerformanceMetrics() {
  const [isSpeedcurveLoaded, setIsSpeedcurveLoaded] = useState(false)

  useEffect(() => {
    initializeSpeedCurveLux()

    if (globalThis.LUX) {
      globalThis.LUX.mark('AuthenticationAppLoaded')
    }

    const handleSpeedcurveLoading = () => {
      setIsSpeedcurveLoaded(true)
    }

    const handleSpeedcurveError = () => {
      reportWarning(
        'SpeedCurve script failed to load, hence RUM data will not be collected for this user session.',
      )
    }

    const scriptElement = createSpeedCurveScriptElement()
    scriptElement.addEventListener('error', handleSpeedcurveError)
    scriptElement.addEventListener('load', handleSpeedcurveLoading)
    document.head.append(scriptElement)

    return () => {
      scriptElement.removeEventListener('error', handleSpeedcurveError)
      scriptElement.removeEventListener('load', handleSpeedcurveLoading)
      scriptElement.remove()
    }
  }, [])

  useEffect(() => {
    if (!isSpeedcurveLoaded || !globalThis.LUX) {
      return
    }

    globalThis.LUX.markLoadTime()
  }, [isSpeedcurveLoaded])

  return null
}
